// src/config/theme.js

function getEnv() {
  if (typeof window === 'undefined') return 'prod';

  const host = window.location.hostname;

  // 1. DEV (IP 172.16.0.14, localhost, 127.0.0.1)
  if (
    host === '172.16.0.14' ||
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host.includes('dev')
  ) {
    return 'dev';
  }

  // 2. PREPROD (preprod.musiq.prod1.steamulo-lyon.com)
  if (host.includes('preprod') || host.includes('steamulo-lyon.com')) {
    return 'preprod';
  }

  // 3. PROD (mus-iq.fr)
  return 'prod';
}

const THEMES = {
  prod: {
    // Rouge (Prod)
    topbarBg: 'bg-[#B3000A] hover:bg-[#990008]',
    topbarRing: 'ring-[#8E0008]',
    bottombarBg: 'from-[#A51A1F] to-[#DB0E16]',
    activeText: 'text-[#A51A1F]',
    badgeActive: 'bg-red-600 text-white ring-white',
    badgeInactive: 'bg-white text-red-600 ring-red-600',
    modalBorder: 'border-red-800 text-red-600',
  },
  preprod: {
    // Vert Émeraude (Préprod)
    topbarBg: 'bg-emerald-600 hover:bg-emerald-700',
    topbarRing: 'ring-emerald-800',
    bottombarBg: 'from-emerald-800 to-emerald-600',
    activeText: 'text-emerald-800',
    badgeActive: 'bg-emerald-600 text-white ring-white',
    badgeInactive: 'bg-white text-emerald-800 ring-emerald-800',
    modalBorder: 'border-emerald-800 text-emerald-700',
  },
  dev: {
    // Violet (Dev)
    topbarBg: 'bg-violet-600 hover:bg-violet-700',
    topbarRing: 'ring-violet-800',
    bottombarBg: 'from-violet-800 to-violet-600',
    activeText: 'text-violet-800',
    badgeActive: 'bg-violet-600 text-white ring-white',
    badgeInactive: 'bg-white text-violet-800 ring-violet-800',
    modalBorder: 'border-violet-800 text-violet-700',
  },
};

export const theme = THEMES[getEnv()];